import React, { useState } from 'react'
import {
Loader,
  Button,
} from 'semantic-ui-react'

import InputField from '../../formComponents/inputField'
import _ from 'lodash'



const AdditionDeduction =(props)=> {
  const{
      
    newValue,
    fieldName,
    setINPUTID,
    penClicked,
    shipmentId,
    rbCounterID,
    updateMerchFeild,
    saveAdditionDeduction,
    disabled

  } =props
 const [tempState,setTempState]=useState({})
const [isLoading,setIsLoading]=useState(false)
 const  renderField=({id,inputLabel,field})=>{

         return(
         
          <div className='total-box shipmentSummary-box'>
          <div className='title'>
            <b>{inputLabel}</b>
          </div>
          <InputField
            id={id}
            type={'text'}
            className={'field-bg total-vals'}
            formDisabled
            subLabelText='$'
            subLabelClass='left-icon no-label'
            value={tempState[`has${field}Change`]
              ?tempState[`${field}NewValue`]
              :props[field]}
            isInteger={true}
          
            onChange={value => {
             
              setTempState((prev)=>{
                return ({...prev,...{[`${field}NewValue`]: value.replace(/[^\d.-]/g, ''),[`has${field}Change`]: true}})
              })
            
            }}
            onBlur={value => {
            }}
            newValue={newValue}
            fieldName={fieldName}
            setINPUTID={setINPUTID}
            penClicked={penClicked}
            shipmentId={shipmentId}
            rbCounterID={rbCounterID}
            disabled={disabled}
          />
          
          
          {<div style={{display:'flex',flexDirection:'row-reverse',marginTop:'.4rem'}}>
            <Button style={{display:'none'}}>
            </Button>
            <Button
              className={'calculate-btn prorate-btn'}
              basic
              color='blue'
              circular
              compact
              disabled={!tempState[`has${field}Change`] || disabled}
              //disabled={ (this.state.enableLineItem === true ? false : isDisabled('grossWeight.weight'))}
              onClick={() => {
                
                setIsLoading(true)
                let newTotalCharges = tempState[`has${field}Change`]?tempState[`${field}NewValue`]:props[field]
                updateMerchFeild(
                  field,
                  parseFloat(newTotalCharges || 0).toFixed(2)
                )
               
                saveAdditionDeduction({field,value:parseFloat(newTotalCharges || 0).toFixed(2)},()=>{
                   updateMerchFeild(
                   `${field}updatedTimeStamp`,
                   Date.now()
                )
                  setIsLoading(false)
                });
                setTempState((prev)=>{
                  return ({...prev,...{[`${field}NewValue`]: null,[`has${field}Change`]: false}})
                })
                
               
              
              }}
            >
              Save & Prorate
            </Button>
            <Button
              className={'calculate-btn prorate-btn'}
              basic
              color='blue'
              circular
              compact
             // disabled={!this.state.hasTotalChargesChange ||(this.state.enableLineItem === true ? false : isDisabled('grossWeight.weight'))}
              onClick={() => {
                setTempState((prev)=>{
                  return ({...prev,...{[`${field}NewValue`]: null,[`has${field}Change`]: false}})
                })
              }}
               disabled={disabled}
            >
              Cancel
            </Button>

          </div>}
        </div>
        
         )
  }


    return (
  <React.Fragment>
     {
      isLoading && <div 
                  className='loader' 
                  style={{
                    fontSize:"large",
                    height:"100vh", 
                    width:"100%", 
                    position:"absolute", 
                    zIndex:'4',
                    background: "white",
                    opacity: "0.5",
                    backdropFilter: "blur(20px)",
                    WebkitBackdropFilter: "blur(20px)", // for Safari support
                }} >  <Loader style={{top:'50px'}} active><b>Loading...</b></Loader>
            </div>
}
               {renderField({id:"totalAdditions",inputLabel:"TOTAL ADDITIONS",field:"totalAdditions"})}
               {renderField({id:"totalDeduction",inputLabel:"TOTAL DEDUCTIONS",field:"totalDeletions"})}
              
               </React.Fragment>
        
    )
  }

  export default AdditionDeduction

